import dayjs from 'dayjs';

const currentYear = String(new Date().getFullYear());

export const formatDateWithTime = (date: string | null) => {
	if (!date) return 'N/A';

	const formattedDate = dayjs(new Date(date)).format('MMM D, YYYY hh:mm a');

	return formattedDate.includes(currentYear) ? formattedDate.replace(`${currentYear} `, '') : formattedDate;
};

export const formatDate = (date: string) => {
	const formattedDate = dayjs(new Date(date)).format('MMM D, YYYY');

	return formattedDate.includes(currentYear) ? formattedDate.replace(`${currentYear} `, '') : formattedDate;
};

export const formatDateForController = (date?: string | Date | dayjs.Dayjs) =>
	dayjs(date || Date.now()).format('YYYY-MM-DD');
